import ResponseCookies_vue_vue_type_script_setup_true_lang_default from "./ResponseCookies.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/response-block/components/ResponseCookies.vue
var ResponseCookies_default = ResponseCookies_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ResponseCookies_default as default };

//# sourceMappingURL=ResponseCookies.vue.js.map